import React from 'react';
import Helmet from 'react-helmet';

import CaseFirstScreen from '../../../components/CaseFirstScreenArea';
import Sharing from '../../../components/Sharing';
import ContactUs from '../../../components/ContactUs';
import SpecialTitle from '../../../components/SpecialTitle';

import './style.scss';
import iMacScreenDesktop from './img/dms-screen-desktop.jpg';
import wand from './img/md-color-wand.svg';

const currentHost = typeof window !== 'undefined' ? window.location.origin : ''
const metaTitle = 'Document Management System | Product Specification Management and PSM Program Development Service';
const metaDiscrip = 'Looking for a company to order Web APP with special requirements? Codenetix team is definitely right choice. Call us today ☎ +7 903 983 3020 if you really liked this client project and order the same one tailor-made web app at best price!';
const metaImg = `${currentHost}/img/cases/dms-sharing.png`;
const metaUrl = `${currentHost}/cases/dms`;
const metaTags = [
  { name: 'description', content: metaDiscrip },
  { name: 'keywords', content: 'codenetix software b2b integration web' },
  { name: 'author', content: 'CODENETIX' },
  { name: 'image', content: `${metaImg}` },
  { name: 'twitter:title', content: metaTitle },
  { name: 'twitter:description', content: metaDiscrip.substr(0, 200) + '...' },
  { name: 'twitter:image', content: metaImg },
  { name: 'twitter:url', content: metaUrl },
  { itemprop: 'name', content: metaTitle },
  { itemprop: 'description', content: metaDiscrip },
  { itemprop: 'image', content: `${metaImg}` },
  { property: 'og:title', content: metaTitle },
  { property: 'og:type', content: 'article' },
  { property: 'og:description', content: metaDiscrip.substr(0, 200) + '...' },
  { property: 'og:url', content: metaUrl },
  { property: 'og:image', content: metaImg },
];

const CaseDMS = () => {
  return (
    <div>
      <div className='cx-main case-page case-dms'>
        <Helmet
          title={metaTitle}
          meta={metaTags}
        />

        <CaseFirstScreen
          companyName='Document Management System'
          caseDenotation='Product Specification Management'
          screens={{ iMac: { image: iMacScreenDesktop } }}
          demoType='desktop'
        />

        <div className='case-description cx-box'>

          <SpecialTitle
            beginning='Lean IT Solutions Help Customer'
            ending='Cut Costs On Procurement'
            iconImg={wand}
          />

          <div className='container'>
            <div className='cx-gap-3' />
            <h3>Centralizing Procurement in a Multinational Company Becomes a Challenge for IT Budget</h3>
            <p>By centralizing procurement function in a large multinational company with high M&A activity, one should expect a good return: not only centralizing leads to a
              larger
              purchase volume and better discount from suppliers, but unification of product specifications decreases need of working capital due to smaller amount of different raw
              materials needed to be on-stock.</p>

            <p>Food Union, a dairy-producing enterprise spanned across Europe, Russia and Eastern Asia, and a valued Client of Codenetix, was in the beginning of that path in 2017.
              Deployment of PSM (Product Specification Management) solution became an essential part of IT landscape as procurement centers responsible for specific materials were
              established across Food Union production sites, with BOM (bill of materials) unification as one of their main tasks.</p>

            <p>First, a large amount of enterprise PSM solutions have been evaluated and put into comparison. Large number of features mark almost every commercial product on the
              market. However, extensive feature list has its flip side: enterprise-level PSM systems are complex in deployment and pricey. Long list of features means more complex
              set up and longer learning curve for end users. Adding to that, implementation costs of $30K+ and maintenance of at least $5K per year make them a choice for really
              big
              enterprises.</p>

            <h3>Tailor-Made Web App as a Working Solution</h3>
            <p>With all that given, the task for a Codenetix team was really challenging: to offer a product that should be more user friendly (as user base is distributed among
              procurement centers in several countries, so zero time invested in user training is a must), web-based (no installation, no corporate LAN), cover all features needed
              for a Customer
              team, and, finally, be less expensive than corporate out-of-the-box solutions.</p>

            <p>Strict adherence to agile methodology and strong teams both on Customer and Codenetix sides made this possible. Thorough prioritisation and cutting away unneeded
              features, using of cutting-edge development tools and frameworks, TDD (test driven development) made development speed truly amazing.</p>

            <p>Web app was released in under than three months, but went live just way before, just after first month of development – a database and data management interface was
              ready as MVP, and «pilot» team, which manages sticks for ice cream, started using the product right away. Other features came in short notice, which allowed whole
              Customer team to collaborate and manage their data in new environment.</p>

            <p>As reported, Food Union have already gained substantial cost savings by implementing new procurement practices. Codenetix team is happy to help our Customer in
              gaining
              these results, supporting future growth.</p>
          </div>
          <div className="cx-gap-1" />
        </div>

        <Sharing
          shareUrl={metaUrl}
          title={metaTitle}
          image={metaImg}
        />

        <div className="cx-gap-3" />

        <ContactUs title='Want a similar project?' subtitle='Drop us a line to chat about it' />
      </div>
    </div>
  )
};

export default CaseDMS;



// WEBPACK FOOTER //
// ./src/pages/cases/dms/index.jsx